<div class="container-fluid">
  <div class="row">
    <div class="col-sm-3 col-3">
      <a class="nav-link">
        <h5>Daftar Panduan</h5>
      </a>
      <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
        <a class="nav-link active" id="v-work-hour-tab" data-toggle="pill" href="#v-work-hour" role="tab"
          aria-controls="v-work-hour" aria-selected="true">Jam Operasional</a>
        <a class="nav-link" id="v-pills-download-tab" data-toggle="pill" href="#v-pills-download" role="tab"
          aria-controls="v-pills-download" aria-selected="false">Unduh User Manual</a>
        <a class="nav-link" id="v-pills-forget-pass-tab" data-toggle="pill" href="#v-pills-forget-pass" role="tab"
          aria-controls="v-pills-forget-pass" aria-selected="false">Lupa Password</a>
        <a class="nav-link" id="v-pills-change-pass-tab" data-toggle="pill" href="#v-pills-change-pass" role="tab"
          aria-controls="v-pills-change-pass" aria-selected="false">Mengganti Password</a>
        <a class="nav-link" id="v-pills-order-item-tab" data-toggle="pill" href="#v-pills-order-item" role="tab"
          aria-controls="v-pills-order-item" aria-selected="false">Membuat Pesanan</a>
        <a class="nav-link" id="v-pills-order-commodity-tab" data-toggle="pill" href="#v-pills-order-commodity" role="tab"
          aria-controls="v-pills-order-commodity" aria-selected="false">Membuat Pesanan Komoditi</a>
        <a class="nav-link" id="v-pills-item-status-tab" data-toggle="pill" href="#v-pills-item-status" role="tab"
          aria-controls="v-pills-item-status" aria-selected="false">Item Status</a>
        <a class="nav-link" id="v-pills-order-status-tab" data-toggle="pill" href="#v-pills-order-status" role="tab"
          aria-controls="v-pills-order-status" aria-selected="false">Status Pesanan</a>
        <a class="nav-link" id="v-pills-order-list-tab" data-toggle="pill" href="#v-pills-order-list" role="tab"
          aria-controls="v-pills-order-list" aria-selected="false">Membuat Order List</a>
        <a class="nav-link" id="v-pills-order-track-tab" data-toggle="pill" href="#v-pills-order-track" role="tab"
          aria-controls="v-pills-order-track" aria-selected="false">Melacak Pesanan</a>
      </div>
    </div>
    <div class="col-sm-9 col-9">
      <h1>Panduan User Sukanda Onelink</h1>
      <br>
      <div class="tab-content" id="v-pills-tabContent">
        <div class="tab-pane fade show active" id="v-work-hour" role="tabpanel" aria-labelledby="v-work-hour-tab">
          <h4>Jam Operasional</h4>
          <p>Order customer yang masuk ke Sukanda Onelink, akan kami proses pada jam berikut : </p>
          <table class="table">
            <tbody>
              <tr>
                <td>Senin - Jumat</td>
                <td>08.00-17.00 WIB</td>
              </tr>
              <tr>
                <td>Sabtu</td>
                <td>08.00-12.00 WIB</td>
              </tr>
              <tr>
                <td>Di luar hari libur nasional</td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="tab-pane fade" id="v-pills-download" role="tabpanel" aria-labelledby="v-pills-download-tab">
          <h4>Unduh User Manual</h4>
          <p>Untuk keterangan dan download manual guide silahkan klik <a
              href="https://open.sukandaonelink.com/docs/file/User Manual Buyer Sukanda OneLink Ver 1.3.pdf">tautan
              ini</a></p>
        </div>
        <div class="tab-pane fade" id="v-pills-forget-pass" role="tabpanel" aria-labelledby="v-pills-forget-pass">
          <h4>Lupa Password</h4>
          <p>Jika Anda lupa password akun, masukan email dan klik <b>Forget Password</b> di halaman login dan Anda akan
            menerima email konfirmasi untuk
            reset password.
          </p>
        </div>
        <div class="tab-pane fade" id="v-pills-change-pass" role="tabpanel" aria-labelledby="v-pills-change-pass">
          <h4>Mengganti Password</h4>
          <p>Waktu pertama kali login, user akan menggunakan password default. User bisa merubah password tersebut
            dengan
            cara di bawah ini:</p>
          <table class="table">
            <tbody>
              <tr>
                <td>1.</td>
                <td>Login dan masuk ke menu utama</td>
              </tr>
              <tr>
                <td>2.</td>
                <td>Klik tombol account yang berlogo profil, yang berada di pojok kanan atas</td>
              </tr>
              <tr>
                <td>3.</td>
                <td>Pilih <b>Change Password</b></td>
              </tr>
              <tr>
                <td>4.</td>
                <td>User akan diminta memasukan password sekarang dan password baru</td>
              </tr>
              <tr>
                <td>5.</td>
                <td>Klik tombol <b>Change Password</b></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="tab-pane fade" id="v-pills-order-item" role="tabpanel" aria-labelledby="v-pills-order-item">
          <h4>Membuat Pesanan</h4>
          <p>Dalam aplikasi Sukanda Onelink ini user diharapkan menyelesaikan order pada satu katalog sebelum membuat
            order baru pada katalog yang lain. Untuk menambahkan produk ke keranjang Anda dan membuat pesanan, berikut
            langkah-langkahnya:</p>
          <table class="table">
            <tbody>
              <tr>
                <td>1.</td>
                <td>Pilih salah satu katalog</td>
              </tr>
              <tr>
                <td>2.</td>
                <td>Melakukan pencarian barang dan tambahkan kuantiti</td>
              </tr>
              <tr>
                <td>3.</td>
                <td>Klik tombol <b>Cart</b> untuk melakukan transaksi</td>
              </tr>
              <tr>
                <td>4.</td>
                <td>Tambahkan keterangan di kolom <b>Delivery Notes</b> ataupun <b>Product Request</b> untuk spesial
                  request ke sales admin</td>
              </tr>
              <tr>
                <td>5.</td>
                <td>Klik <b>Submit</b></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="tab-pane fade" id="v-pills-order-commodity" role="tabpanel" aria-labelledby="v-pills-order-commodity">
          <h4>Membuat Pesanan Barang Komoditi</h4>
          <p>Cara membuat pesanan barang komoditi:</p>
          <table class="table">
            <tbody>
              <tr>
                <td>1.</td>
                <td>Pilih salah satu katalog</td>
              </tr>
              <tr>
                <td>2.</td>
                <td>Melakukan pencarian barang dan tambahkan jumlah barang komoditi.</td>
              </tr>
              <tr>
                <td>3.</td>
                <td>Klik tombol <b>Cart</b> untuk melakukan transaksi</td>
              </tr>
              <tr>
                <td>4.</td>
                <td>Tambahkan keterangan di kolom <b>Delivery Notes</b> ataupun <b>Product Request</b> untuk spesial
                  request ke sales admin</td>
              </tr>
              <tr>
                <td>5.</td>
                <td>Klik <b>Submit</b></td>
              </tr>
              <tr>
                <td>6.</td>
                <td>Setelah itu pembeli bisa melakukan tawar menawar/negosiasi dengan sales admin melalui telepon, WA, sms
                  dan sebagainya </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="tab-pane fade" id="v-pills-item-status" role="tabpanel" aria-labelledby="v-pills-item-status">
          <h4>Item Status</h4>
        <p>Berikut merupakan keterangan untuk status barang yang ada di katalog</p>
        <table class="table table-striped">
          <thead class="thead-dark">
            <tr>
              <th>Status</th>
              <th>Keterangan</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>No Stock</td>
              <td>Stok barang tidak tersedia / habis</td>
            </tr>
            <tr>
              <td>Limited</td>
              <td>Stok barang tinggal sedikit / terbatas</td>
            </tr>
          </tbody>
        </table>
        </div>
        <div class="tab-pane fade" id="v-pills-order-status" role="tabpanel" aria-labelledby="v-pills-order-status">
          <h4>Status Pesanan</h4>
        <p>Untuk melihat sejauh mana proses pesanan yang telah dibuat, user bisa klik menu <b>My History</b> yang ada di
          pojok kanan atas.
          Berikut merupakan keterangan untuk status yang ada di riwayat pemesanan</p>
        <table class="table table-striped">
          <thead class="thead-dark">
            <tr>
              <th>Status</th>
              <th>Keterangan</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Draft</td>
              <td>Customer masih dalam proses untuk membuat pesanan</td>
            </tr>
            <tr>
              <td>Submitted</td>
              <td>Pesanan telah disubmit / dikirim ke sales admin untuk dilakukan proses verifikasi</td>
            </tr>
            <tr>
              <td>Response Required</td>
              <td>Di dalam pesanan terdapat barang komoditi sehingga memerlukan pengajuan harga ke sales admin</td>
            </tr>
            <tr>
              <td>Processed</td>
              <td>Pesanan telah diverifikasi oleh sales admin dan sedang diproses oleh penjual</td>
            </tr>
            <tr>
              <td>Canceled</td>
              <td>Pesanan dibatalkan</td>
            </tr>
            <tr>
              <td>Delivered</td>
              <td>Pesanan sedang diperjalanan untuk proses pengiriman</td>
            </tr>
            <tr>
              <td>Received</td>
              <td>Pesanan telah diterima oleh customer</td>
            </tr>
          </tbody>
        </table>
        </div>
        <div class="tab-pane fade" id="v-pills-order-track" role="tabpanel" aria-labelledby="v-pills-order-track">
          <h4>Melacak Pesanan</h4>
        <p>Kustomer bisa melihat sampai di mana proses atas pesanan yang telah mereka buat</p>
        <p>Cara melihat proses pesanan:</p>
        <table class="table">
          <tbody>
            <tr>
              <td>1.</td>
              <td>Masuk ke menu <b>My History</b></td>
            </tr>
            <tr>
              <td>2.</td>
              <td>Pilih salah satu riwayat pesanan dengan klik id nya, maka user akan melihat detail pesanan</td>
            </tr>
            <tr>
              <td>3.</td>
              <td>Klik lagi tombol tiga garis yang ada di kanan atas menu, dan kemudian pilih <b>Deliveries Info</b>
              </td>
            </tr>
            <tr>
              <td>4.</td>
              <td>User akan melihat status pesanan yang telah dibuat </td>
            </tr>
          </tbody>
        </table>
        </div>
        <div class="tab-pane fade" id="v-pills-order-list" role="tabpanel" aria-labelledby="v-pills-order-list">
          <h4>Membuat Order List</h4>
        <p>Order list adalah sebuah fasilitas untuk membuat template yang bertujuan untuk membantu
          mempercepat proses pemesanan oleh pembeli. Selain itu berguna juga jika pembeli ingin melakukan
          pemesanan ulang
        </p>
        <p>Cara membuat order list:</p>
        <table class="table">
          <tbody>
            <tr>
              <td>1.</td>
              <td>Klik <b>Create List</b></td>
            </tr>
            <tr>
              <td>2.</td>
              <td>Pilih salah satu katalog</td>
            </tr>
            <tr>
              <td>3.</td>
              <td>Masukan nama untuk template pesanan</td>
            </tr>
            <tr>
              <td>4.</td>
              <td>Pilih salah satu item dan masukan jumlah pesanan</td>
            </tr>
            <tr>
              <td>5.</td>
              <td>Klik <b>Save</b>, maka pembeli akan kembali ke menu utama</td>
            </tr>
            <tr>
              <td>6.</td>
              <td>Klik tanda (+) plus disebelah nama template pesanan, maka item akan otomatis masuk ke keranjang</td>
            </tr>
          </tbody>
        </table>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="row">

    <div class="col-sm-3 col-3" id="myScrollspy">


      <ul class="nav flex-column sidebar">
        <a class="nav-link" href="help#">
          <h5>Daftar Panduan</h5>
        </a>
        <li class="nav-item">
          <a class="nav-link" href="help#work-hour">Jam Operasional</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="help#download">Unduh User Manual</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="help#forgetPass">Lupa Password</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="help#changePass">Mengganti Password</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="help#orderitem">Membuat Pesanan</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="help#orderitemcommodity">Membuat Pesanan Komoditi</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="help#itemstatus">Item Status</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="help#orderstatus">Status Pesanan</a>
        </li>

        <li class="nav-item">
          <a class="nav-link" href="help#orderlist">Membuat Order List</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="help#lacakorder">Melacak Pesanan</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="help#lacakorder">Melacak Pesanan</a>
        </li>
      </ul>
    </div>
    <div class="col-sm-9 col-9">
      <h1>Panduan User Sukanda Onelink</h1>
      <br>

      <br>
      <div id="work-hour">
        <h4>Jam Operasional</h4>
        <p>Order customer yang masuk ke Sukanda Onelink, akan kami proses pada jam berikut : </p>
        <table class="table">
          <tbody>
            <tr>
              <td>Senin - Jumat</td>
              <td>08.00-17.00 WIB</td>
            </tr>
            <tr>
              <td>Sabtu</td>
              <td>08.00-12.00 WIB</td>
            </tr>
            <tr>
              <td>Di luar hari libur nasional</td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
      <br>
      <div id="download">
        <h4>Unduh User Manual</h4>
        <p>Untuk keterangan dan download manual guide silahkan klik <a
            href="https://open.sukandaonelink.com/docs/file/User Manual Buyer Sukanda OneLink Ver 1.3.pdf">tautan
            ini</a></p>
      </div>
      <br>
      <div id="forgetPass">
        <h4>Lupa Password</h4>
        <p>Jika Anda lupa password akun, masukan email dan klik <b>Forget Password</b> di halaman login dan Anda akan
          menerima email konfirmasi untuk
          reset password.
        </p>
      </div>
      <br>
      <div id="changePass">
        <h4>Mengganti Password</h4>
        <p>Waktu pertama kali login, user akan menggunakan password default. User bisa merubah password tersebut dengan
          cara di bawah ini:</p>
        <table class="table">
          <tbody>
            <tr>
              <td>1.</td>
              <td>Login dan masuk ke menu utama</td>
            </tr>
            <tr>
              <td>2.</td>
              <td>Klik tombol account yang berlogo profil, yang berada di pojok kanan atas</td>
            </tr>
            <tr>
              <td>3.</td>
              <td>Pilih <b>Change Password</b></td>
            </tr>
            <tr>
              <td>4.</td>
              <td>User akan diminta memasukan password sekarang dan password baru</td>
            </tr>
            <tr>
              <td>5.</td>
              <td>Klik tombol <b>Change Password</b></td>
            </tr>
          </tbody>
        </table>
      </div>
      <br>
      <div id="orderitem">
        <h4>Membuat Pesanan</h4>
        <p>Dalam aplikasi Sukanda Onelink ini user diharapkan menyelesaikan order pada satu katalog sebelum membuat
          order baru pada katalog yang lain. Untuk menambahkan produk ke keranjang Anda dan membuat pesanan, berikut
          langkah-langkahnya:</p>
        <table class="table">
          <tbody>
            <tr>
              <td>1.</td>
              <td>Pilih salah satu katalog</td>
            </tr>
            <tr>
              <td>2.</td>
              <td>Melakukan pencarian barang dan tambahkan kuantiti</td>
            </tr>
            <tr>
              <td>3.</td>
              <td>Klik tombol <b>Cart</b> untuk melakukan transaksi</td>
            </tr>
            <tr>
              <td>4.</td>
              <td>Tambahkan keterangan di kolom <b>Delivery Notes</b> ataupun <b>Product Request</b> untuk spesial
                request ke sales admin</td>
            </tr>
            <tr>
              <td>5.</td>
              <td>Klik <b>Submit</b></td>
            </tr>
          </tbody>
        </table>
      </div>
      <br>
      <div id="orderitemcommodity">
        <h4>Membuat Pesanan Barang Komoditi</h4>
        <p>Cara membuat pesanan barang komoditi:</p>
        <table class="table">
          <tbody>
            <tr>
              <td>1.</td>
              <td>Pilih salah satu katalog</td>
            </tr>
            <tr>
              <td>2.</td>
              <td>Melakukan pencarian barang dan tambahkan jumlah barang komoditi.</td>
            </tr>
            <tr>
              <td>3.</td>
              <td>Klik tombol <b>Cart</b> untuk melakukan transaksi</td>
            </tr>
            <tr>
              <td>4.</td>
              <td>Tambahkan keterangan di kolom <b>Delivery Notes</b> ataupun <b>Product Request</b> untuk spesial
                request ke sales admin</td>
            </tr>
            <tr>
              <td>5.</td>
              <td>Klik <b>Submit</b></td>
            </tr>
            <tr>
              <td>6.</td>
              <td>Setelah itu pembeli bisa melakukan tawar menawar/negosiasi dengan sales admin melalui telepon, WA, sms
                dan sebagainya </td>
            </tr>
          </tbody>
        </table>
      </div>
      <br>

      <div id="itemstatus">
        <h4>Item Status</h4>
        <p>Berikut merupakan keterangan untuk status barang yang ada di katalog</p>
        <table class="table table-striped">
          <thead class="thead-dark">
            <tr>
              <th>Status</th>
              <th>Keterangan</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>No Stock</td>
              <td>Stok barang tidak tersedia / habis</td>
            </tr>
            <tr>
              <td>Limited</td>
              <td>Stok barang tinggal sedikit / terbatas</td>
            </tr>
          </tbody>
        </table>
      </div>
      <br>
      <div id="orderstatus">
        <h4>Status Pesanan</h4>
        <p>Untuk melihat sejauh mana proses pesanan yang telah dibuat, user bisa klik menu <b>My History</b> yang ada di
          pojok kanan atas.
          Berikut merupakan keterangan untuk status yang ada di riwayat pemesanan</p>
        <table class="table table-striped">
          <thead class="thead-dark">
            <tr>
              <th>Status</th>
              <th>Keterangan</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Draft</td>
              <td>Customer masih dalam proses untuk membuat pesanan</td>
            </tr>
            <tr>
              <td>Submitted</td>
              <td>Pesanan telah disubmit / dikirim ke sales admin untuk dilakukan proses verifikasi</td>
            </tr>
            <tr>
              <td>Response Required</td>
              <td>Di dalam pesanan terdapat barang komoditi sehingga memerlukan pengajuan harga ke sales admin</td>
            </tr>
            <tr>
              <td>Processed</td>
              <td>Pesanan telah diverifikasi oleh sales admin dan sedang diproses oleh penjual</td>
            </tr>
            <tr>
              <td>Canceled</td>
              <td>Pesanan dibatalkan</td>
            </tr>
            <tr>
              <td>Delivered</td>
              <td>Pesanan sedang diperjalanan untuk proses pengiriman</td>
            </tr>
            <tr>
              <td>Received</td>
              <td>Pesanan telah diterima oleh customer</td>
            </tr>
          </tbody>
        </table>
      </div>
      <br>
      <div id="orderlist">
        <h4>Membuat Order List</h4>
        <p>Order list adalah sebuah fasilitas untuk membuat template yang bertujuan untuk membantu
          mempercepat proses pemesanan oleh pembeli. Selain itu berguna juga jika pembeli ingin melakukan
          pemesanan ulang
        </p>
        <p>Cara membuat order list:</p>
        <table class="table">
          <tbody>
            <tr>
              <td>1.</td>
              <td>Klik <b>Create List</b></td>
            </tr>
            <tr>
              <td>2.</td>
              <td>Pilih salah satu katalog</td>
            </tr>
            <tr>
              <td>3.</td>
              <td>Masukan nama untuk template pesanan</td>
            </tr>
            <tr>
              <td>4.</td>
              <td>Pilih salah satu item dan masukan jumlah pesanan</td>
            </tr>
            <tr>
              <td>5.</td>
              <td>Klik <b>Save</b>, maka pembeli akan kembali ke menu utama</td>
            </tr>
            <tr>
              <td>6.</td>
              <td>Klik tanda (+) plus disebelah nama template pesanan, maka item akan otomatis masuk ke keranjang</td>
            </tr>
          </tbody>
        </table>
      </div>
      <br>
      <div id="lacakorder">
        <h4>Melacak Pesanan</h4>
        <p>Kustomer bisa melihat sampai di mana proses atas pesanan yang telah mereka buat</p>
        <p>Cara melihat proses pesanan:</p>
        <table class="table">
          <tbody>
            <tr>
              <td>1.</td>
              <td>Masuk ke menu <b>My History</b></td>
            </tr>
            <tr>
              <td>2.</td>
              <td>Pilih salah satu riwayat pesanan dengan klik id nya, maka user akan melihat detail pesanan</td>
            </tr>
            <tr>
              <td>3.</td>
              <td>Klik lagi tombol tiga garis yang ada di kanan atas menu, dan kemudian pilih <b>Deliveries Info</b>
              </td>
            </tr>
            <tr>
              <td>4.</td>
              <td>User akan melihat status pesanan yang telah dibuat </td>
            </tr>
          </tbody>
        </table>
      </div>
      <br>
    </div>
  </div>` -->